// extracted by mini-css-extract-plugin
module.exports = {"slider-milestones":"style_slider-milestones__fUYEc"};